module.exports = __webpack_public_path__ + "img/grandmother.be5030ca.webp";